import { Box, Button, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    maxWidth: 'none',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const DialogContainer = styled(Box)(() => ({
  width: '700px',
  display: 'flex',
  flexDirection: 'column',
  padding: '48px',
}));

export const ButtonsContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '32px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '300px',
  textTransform: 'lowercase',
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  span: {
    marginRight: '8px',
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  maxWidth: '300px',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
